/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_4_DescInputs */

const en_mk_sec_4_desc = /** @type {(inputs: Mk_Sec_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who — or which agent, acting for whom — did what, and when; exportable for PDP-law compliance.`)
};

const id_mk_sec_4_desc = /** @type {(inputs: Mk_Sec_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa — atau agen atas nama siapa — melakukan apa, kapan; siap diekspor untuk UU PDP.`)
};

/**
* | output |
* | --- |
* | "Who — or which agent, acting for whom — did what, and when; exportable for PDP-law compliance." |
*
* @param {Mk_Sec_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_4_desc = /** @type {((inputs?: Mk_Sec_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_4_desc(inputs)
	return en_mk_sec_4_desc(inputs)
});